
import { useNavigate, useParams } from 'react-router-dom';
import InterviewResultScreen from '../video-interview/components/InterviewResultScreen';

/**
 * Renders the dark-mode Interview Result Screen as the main detail page.
 * This unifies usage of the preferred dark-mode UI for reviewing interview results.
 */
export default function InterviewDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-black text-white">
        <p>Interview ID not found.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <InterviewResultScreen
        questions={[]} // Data is fetched internally by InterviewResultScreen using interviewId
        handleFinishInterview={() => navigate('/dashboard')}
        interviewId={id}
        pendingUploadsCount={0}
        isDark={true}
      />
    </div>
  );
}
